import { render, staticRenderFns } from "./icanResult.vue?vue&type=template&id=0b0207fa&scoped=true&"
import script from "./icanResult.vue?vue&type=script&lang=js&"
export * from "./icanResult.vue?vue&type=script&lang=js&"
import style0 from "./icanResult.vue?vue&type=style&index=0&id=0b0207fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0207fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
